<template>
    <div v-if="domainName" class="domains | u-wizard-padding-bottom">
        <domain-result v-for="domain in domains" :key="domain.domain" :domain="domain" :ownedDomains="ownedDomains" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DomainResult from './DomainResult.vue';

export default {
    components: {
        DomainResult
    },
    props: {
        ownedDomains: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        ...mapGetters({
            domains: 'domains/domains',
            domainName: 'domains/domainName'
        })
    }
};
</script>
